import {
    CENTRAL_INSTANCE_LOGIN_LICENSE_NAME,
    CENTRAL_INSTANCE_ADMIN_LICENSE_NAME,
} from '../../../constants';
import {
    getCombinedToken as getAccessToken,
    isLoggedInWithBentleyToken,
} from '../../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { setLicenseToken } from '../../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { EntitlementsApiClient } from '../../entitlementsClient/EntitlementsApiClient';
import { AuthenticatedIdentityApiClient } from '../AuthenticatedIdentityApiClient';

const createLicenseTokenApi = (
    apiClient: typeof AuthenticatedIdentityApiClient | typeof EntitlementsApiClient,
    urlPrefix: string,
) =>
    apiClient.injectEndpoints({
        endpoints: (build) => ({
            licenseToken: build.mutation<void, string>({
                query: (entitlementId) => ({
                    url: `${urlPrefix}/authz/entitlements/${entitlementId}.jwt?${CENTRAL_INSTANCE_LOGIN_LICENSE_NAME}&${CENTRAL_INSTANCE_ADMIN_LICENSE_NAME}&consumptionMode=checkout&doConsume=False`,
                    responseHandler: (response) =>
                        response.text().then((s) => {
                            const token = s.trimStart().trimEnd();

                            // Empty body with a 200 response signifies a CORS violation.
                            if (!token.length) {
                                throw new Error('CORS failure');
                            }
                            if (response.status === 200) {
                                if (isLoggedInWithBentleyToken()) {
                                    setLicenseToken(`${getAccessToken()?.access_token}`);
                                } else {
                                    setLicenseToken(token);
                                }
                            }
                            // If the user doesn't have access to the specified license features, the endpoint will still
                            // return a 200 response, and the encoded content of the license tokens will specify that the
                            // user's license isn't valid. Unfortunately, this means we have no way of knowing that the user
                            // isn't allowed until they try to connect to Central.
                            return { data: token };
                        }),
                }),
            }),
        }),
    });

export const CentralSeequentLicenseTokenApi = createLicenseTokenApi(
    AuthenticatedIdentityApiClient,
    '',
);
export const CentralBentleyLicenseTokenApi = createLicenseTokenApi(
    EntitlementsApiClient,
    '/v1/licenses/id/central',
);

export const { useLicenseTokenMutation: useCentralSeequentLicenseTokenMutation } =
    CentralSeequentLicenseTokenApi;
export const { useLicenseTokenMutation: useCentralBentleyLicenseTokenMutation } =
    CentralBentleyLicenseTokenApi;
